import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import { toastService } from '~/@common/services/toast.service'
import { FloatingLoader } from '~/@common/ui/(Loader)/FloatingLoader'

import { useNaverWorksLogin } from './useNaverWorksLogin'

/**
 * 네이버 웍스(웨일 스페이스) SSO 콜백 페이지 (/whale/callback).
 *
 * 네이버 웍스가 인가 완료 후 `?code=...` 또는 `?error=...`로 리다이렉트한다.
 * - code 있음 → useNaverWorksLogin.login(code)로 서버 로그인 수행
 * - error 또는 code 없음 → 토스트 + 로그인 페이지로 복귀
 *
 * ⚠️ /whale/callback 경로는 네이버 웍스 console에 등록된 redirect_uri — 절대 변경 금지.
 */
const AiOnOAuthCallbackPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const code = searchParams.get('code')
  const error = searchParams.get('error')

  const { login } = useNaverWorksLogin()

  useEffect(() => {
    if (!code || error) {
      toastService.error('웨일스페이스 로그인을 진행할 수 없습니다.\n다시 시도해주세요.')
      navigate(routeName.login, { replace: true })
      return
    }

    login(code)
    // mount 시 한 번만 login 수행
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, error])

  return <FloatingLoader />
}

export default AiOnOAuthCallbackPage
